import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Compare = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="compare icon"
    className={`shrink-0 h-${size} w-${size} ${className}`}
    viewBox="0 0 64 64"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M53.5 23C51.9 23 49.8333 24.3333 49 25C47.8 23.4 45.5 23 44.5 23V34.5C45.1667 35.1667 47 36.7 49 37.5C51 36.5 57.5 31 57.5 28C57.5 25 55.5 23 53.5 23Z"
      className={`color-iconPrimary-disabled ${pathClass}`}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M39 7H25C22.7909 7 21 8.79086 21 11V43C21 45.2091 22.7909 47 25 47H39C41.2091 47 43 45.2091 43 43V11C43 8.79086 41.2091 7 39 7ZM25 4C21.134 4 18 7.13401 18 11V43C18 46.866 21.134 50 25 50H39C42.866 50 46 46.866 46 43V11C46 7.13401 42.866 4 39 4H25Z"
      className={`color-iconBrand-default ${pathClass}`}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M27.4118 13L23 17.8488L32.1366 27.4886L41.07 17.8537L36.6536 13H27.4118Z"
      className={`color-iconBrand-default ${pathClass}`}
    />
    <path
      d="M27.0939 17.8071L32.1126 23.1021L36.9966 17.8346L35.3273 16H28.7382L27.0939 17.8071Z"
      className={`color-iconPrimary-disabled ${pathClass}`}
    />
    <path
      d="M15 17H7C4.79086 17 3 18.7909 3 21V53C3 55.2091 4.79086 57 7 57H21C23.2091 57 25 55.2091 25 53H28C28 56.866 24.866 60 21 60H7C3.13401 60 0 56.866 0 53V21C0 17.134 3.13401 14 7 14H15V17Z"
      className={`color-iconBrand-default ${pathClass}`}
    />
    <path
      d="M49 17H57C59.2091 17 61 18.7909 61 21V53C61 55.2091 59.2091 57 57 57H43C40.7909 57 39 55.2091 39 53H36C36 56.866 39.134 60 43 60H57C60.866 60 64 56.866 64 53V21C64 17.134 60.866 14 57 14H49V17Z"
      className={`color-iconBrand-default ${pathClass}`}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25 33.5C25 32.6716 25.6716 32 26.5 32H37.5C38.3284 32 39 32.6716 39 33.5C39 34.3284 38.3284 35 37.5 35H26.5C25.6716 35 25 34.3284 25 33.5Z"
      className={`color-iconBrand-default ${pathClass}`}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7 43.5C7 42.6716 7.67157 42 8.5 42H13.5C14.3284 42 15 42.6716 15 43.5C15 44.3284 14.3284 45 13.5 45H8.5C7.67157 45 7 44.3284 7 43.5Z"
      className={`color-iconBrand-default ${pathClass}`}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M49 43.5C49 42.6716 49.6716 42 50.5 42H55.5C56.3284 42 57 42.6716 57 43.5C57 44.3284 56.3284 45 55.5 45H50.5C49.6716 45 49 44.3284 49 43.5Z"
      className={`color-iconBrand-default ${pathClass}`}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25 40.5C25 39.6716 25.6716 39 26.5 39H37.5C38.3284 39 39 39.6716 39 40.5C39 41.3284 38.3284 42 37.5 42H26.5C25.6716 42 25 41.3284 25 40.5Z"
      className={`color-iconBrand-default ${pathClass}`}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7 50.5C7 49.6716 7.67157 49 8.5 49H15.5C16.3284 49 17 49.6716 17 50.5C17 51.3284 16.3284 52 15.5 52H8.5C7.67157 52 7 51.3284 7 50.5Z"
      className={`color-iconBrand-default ${pathClass}`}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M47 50.5C47 49.6716 47.6716 49 48.5 49H55.5C56.3284 49 57 49.6716 57 50.5C57 51.3284 56.3284 52 55.5 52H48.5C47.6716 52 47 51.3284 47 50.5Z"
      className={`color-iconBrand-default ${pathClass}`}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M47.8287 26.437C47.1813 25.6278 46.1437 24.5 44.5 24.5V21.5C46.5668 21.5 48.0645 22.4457 49.0448 23.3394C49.3123 23.1158 49.6068 22.8937 49.9232 22.6855C50.8467 22.0781 52.0955 21.5 53.5 21.5C56.537 21.5 59 24.3968 59 28C59 30.6677 57.1993 32.9244 55.3957 34.5992C53.6826 36.1899 51.6446 37.5438 50.1872 38.5119C50.0645 38.5934 49.946 38.6721 49.8321 38.7481L49 39.3028L48.168 38.7481C48.056 38.6735 47.9397 38.5961 47.8194 38.5162C46.6137 37.7151 45.0137 36.652 43.5386 35.4203L45.4614 33.1175C46.6286 34.0921 47.8892 34.9561 48.9999 35.698C50.3839 34.7734 51.9951 33.663 53.3543 32.4008C55.0507 30.8256 56 29.3323 56 28C56 25.6032 54.463 24.5 53.5 24.5C52.9045 24.5 52.2333 24.7569 51.5718 25.192C50.919 25.6213 50.4105 26.1363 50.1741 26.4336L49.0035 27.9056L47.8287 26.437Z"
      className={`color-iconBrand-default ${pathClass}`}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.4422 25.9312H7.15539C5.21794 25.9312 4.41239 28.4104 5.97981 29.5492L9.44793 32.0689L8.12323 36.1459C7.52452 37.9886 9.63348 39.5208 11.2009 38.382L14.669 35.8623L18.1371 38.382C19.5 36.1459 20.3336 33.4337 19.8901 32.0689C19.8901 29.5492 19.8901 28.5 19.8901 25.9312H17.8958L16.5711 21.8541C15.9724 20.0115 13.3656 20.0115 12.7669 21.8541L11.4422 25.9312Z"
      className={`color-iconBrand-default ${pathClass}`}
    />
    <path
      d="M15.7162 28.9312L14.6691 25.7083L13.6219 28.9312H10.2331L12.9747 30.923L11.9275 34.1459L14.6691 32.1541L17.4106 34.1459L16.3634 30.923L19.105 28.9312H15.7162Z"
      className={`color-iconPrimary-disabled ${pathClass}`}
    />
  </svg>
)
